namespace $.$$ {

	export class $shm_button_copy extends $.$shm_button_copy {

		@ $mol_mem
		html() {
			return $mol_html_encode( this.text() )
		}

		showed() {
			return this.copied() && ( this.hovered() || this.focused() )
		}

		align() {
			const anchor = this.view_rect()
			if( !anchor ) return 'bottom_center'

			const viewport = this.$.$mol_window.size()
			const bubble = this.Follower().view_rect()
			const width = bubble?.width ?? 0
			const height = bubble?.height ?? 0
			const gap = 8
			const center = anchor.left + anchor.width / 2

			const horizontal = center - width / 2 < gap
				? 'right'
				: center + width / 2 > viewport.width - gap
					? 'left'
					: 'center'

			const vertical = anchor.bottom + height > viewport.height - gap
				&& anchor.top - height >= gap
				? 'top'
				: 'bottom'

			return `${ vertical }_${ horizontal }`
		}

		status_text() {
			return 'Скопировано'
		}

		click( event?: Event ) {
			$mol_button_copy.prototype.click.call( this.Button(), event )
			this.copied( true )
		}

		event_hide( event?: MouseEvent ) {
			super.event_hide( event )
			this.copied( false )
		}

		@ $mol_action
		event_blur( event?: FocusEvent ) {
			const next = event?.relatedTarget
			if( next && 'nodeType' in next && this.dom_node().contains( next as Node ) ) return
			this.copied( false )
		}

	}
}
